import {
  LitheElement,
  LitheFC,
  redrawFragment,
} from '@wheelbox/lithejs-engine';

import withPageTitle from '@lib/page';
import { apiFetch } from '@lib/api';

import BlogPosts from './blog-posts';

import { BlogPostData } from './types';

const BlogPage: LitheFC = ({
  id = 'docs-page',
  testId = 'docs-page',
}): LitheElement<'main'> => {
  withPageTitle('LitheJS | Blog');

  let posts: BlogPostData[] = [];

  const onMountHandler = async () => {
    const response = await apiFetch('/posts', {
      method: 'GET',
    });

    posts = await response.json();

    redrawFragment(`${id}-posts`);
  };

  return [
    'main',
    { id, 'data-testid': testId, class: 'page-grid', onmount: onMountHandler },
    () => BlogPosts({ id: `${id}-posts`, posts }),
  ];
};

export default BlogPage;
